/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TournamentEndpointService, TournamentOverviewDto } from '@api';

@Component({
  selector: 'app-tournament-overview',
  templateUrl: './tournament-overview.component.html',
  styleUrl: './tournament-overview.component.scss',
})
export class TournamentOverviewComponent implements OnInit {
  tournamentOverview: TournamentOverviewDto | undefined;
  tournamentId = input.required<number>();

  get registrationEndAsDate() {
    return this.tournamentOverview?.registrationEnd
      ? new Date(this.tournamentOverview.registrationEnd)
      : null;
  }

  get koMatchesStatus() {
    if (this.tournamentOverview?.allKoMatches === 0) {
      return 'Not started yet';
    } else if (this.tournamentOverview?.playedKoMatches !== this.tournamentOverview?.allKoMatches) {
      return 'In Progress';
    } else {
      return 'Done';
    }
  }

  get qualificationMatchesStatus() {
    if (this.tournamentOverview?.allQualificationMatches === 0) {
      return 'Not started yet';
    } else if (
      this.tournamentOverview?.playedQualificationMatches !==
      this.tournamentOverview?.allQualificationMatches
    ) {
      return 'In Progress';
    } else {
      return 'Done';
    }
  }

  constructor(
    private tournamentService: TournamentEndpointService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.tournamentService.getTournamentOverview(this.tournamentId()).subscribe({
      next: (data: TournamentOverviewDto) => {
        this.tournamentOverview = data;
      },
      error: error => {
        this.defaultServiceErrorHandling(error);
      },
    });
  }

  private defaultServiceErrorHandling(error: HttpErrorResponse) {
    let errorMessage = '';
    if (!error.error) {
      errorMessage = 'fetching tournament';
    } else if (typeof error.error === 'object') {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }
    this.snackBar.open(errorMessage, 'Close', {
      duration: 5000,
    });
  }
}
